import { padStart } from 'lodash-es'
import { Icon, ITextProps, Text } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export const StatusText: React.FC<{ status: number } & ITextProps> = ({
  status,
  ...props
}) => {
  const { t } = useTranslation()
  const iconName = React.useMemo(
    () =>
      ({
        0: 'Edit',
        1: 'FavoriteStar',
        2: 'View',
        3: 'HourGlass',
        4: 'Accept',
        5: 'Important',
        6: 'View',
        7: 'Sync',
        8: 'Archive',
        9: 'CalculatorMultiply',
        10: 'Blocked2',
      }[status]),
    [status]
  )

  return (
    <Text {...props}>
      <Icon iconName={iconName} />
      &nbsp;
      {padStart(`${status}`, 2, '0')}. {t(`field.status.${status}`)}
    </Text>
  )
}
